import { z } from "zod";
import { reduceLayerToggles, type LayerToggleState } from "./layerToggles";
import type { MapLayer } from "./mapLayer";

export function normalizeLayerSnapshot(
  layers: readonly MapLayer[],
  ids: Iterable<string>,
): string[] {
  let state: LayerToggleState = {
    enabledIds: new Set(),
    erroredIds: new Set(),
  };
  for (const id of ids) {
    if (!state.enabledIds.has(id))
      state = reduceLayerToggles(layers, state, { type: "toggle", id });
  }
  return [...state.enabledIds];
}

export function layerSnapshotSchema(layers: readonly MapLayer[]) {
  return z
    .array(z.string())
    .transform((ids) => normalizeLayerSnapshot(layers, ids))
    .optional()
    .catch(undefined);
}
